// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * api-gateway签名
 * @returns {*}
 */
export function apiGatewaySign(body, appid, version, secret) {
  return axios.post('/system/dsl/api-gateway/sign?appid=' + appid + "&version=" + version + "&secret=" + secret, body)
    .then(res => res.data);
}
export function openApiSign(body, appid, secret) {
  return axios.post('/system/dsl/open-api/sign?appid=' + appid + "&secret=" + secret, body)
    .then(res => res.data);
}
export function createJiraTask(body) {
  return axios.post('/system/dsl/createJiraTask', body)
    .then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/dsl.js